'use client';
import './style.scss';
import Image from 'next/image';
import React from 'react';

import { useTranslation } from '@/hooks/useTranslations';
import ClientAreaImag from '@/public/assets/Images/client-area.png';

export const ClientAreaSection = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className={'bigContent'}>
        <div className={'clientAreaSection'}>
          <div className={'clientAreaSectionInformation'}>
            <h3 className={'clientAreaTitleText'}>{t('client_area_title')}</h3>
            <p className={'clientAreaDescriptionText'}>{t('client_area_description')}</p>
            <a
              className={'exploreClientAreaButton button btnTypeBig btnTypeOrange'}
              href="https://clienthub.popokgaming.com"
              target={'_blank'}
            >
              {t('explore_client_area')}
              <i className="bc-i-go-to btnIcon btnIconSmall" />
            </a>
          </div>
          <Image className={'clientAreaImage'} src={ClientAreaImag} fill alt="client area" />
        </div>
      </div>
    </section>
  );
};
